// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"efe08db1","186":"d70f918e","213":"c275e511","225":"e5c4d2f9","292":"5d55af81","344":"9dd6efb1","372":"20c0c248","377":"a9d38392","738":"7c34c39d","841":"9eeee8e0","856":"e19cb149"}[chunkId] + ".chunk.js";
};